import {
    TAX_CHECKLIST_EYEBROW,
    TAX_CHECKLIST_GROUP1_ITEM1, TAX_CHECKLIST_GROUP1_ITEM2, TAX_CHECKLIST_GROUP1_ITEM3, TAX_CHECKLIST_GROUP1_TITLE,
    TAX_CHECKLIST_GROUP2_ITEM1, TAX_CHECKLIST_GROUP2_ITEM2, TAX_CHECKLIST_GROUP2_ITEM3, TAX_CHECKLIST_GROUP2_TITLE,
    TAX_CHECKLIST_GROUP3_ITEM1, TAX_CHECKLIST_GROUP3_ITEM2, TAX_CHECKLIST_GROUP3_ITEM3, TAX_CHECKLIST_GROUP3_TITLE,
    TAX_CHECKLIST_SUBTITLE, TAX_CHECKLIST_TITLE,
    TAX_CTA_BUTTON, TAX_CTA_SUBTITLE, TAX_CTA_TITLE,
    TAX_DISCLAIMER_BODY, TAX_DISCLAIMER_DONT_1, TAX_DISCLAIMER_DONT_2, TAX_DISCLAIMER_DONT_3, TAX_DISCLAIMER_DONT_LABEL,
    TAX_DISCLAIMER_DO_1, TAX_DISCLAIMER_DO_2, TAX_DISCLAIMER_DO_3, TAX_DISCLAIMER_DO_4, TAX_DISCLAIMER_DO_LABEL,
    TAX_DISCLAIMER_EYEBROW, TAX_DISCLAIMER_TITLE,
    TAX_FAQ_A1, TAX_FAQ_A2, TAX_FAQ_A3, TAX_FAQ_A4, TAX_FAQ_A5, TAX_FAQ_A6,
    TAX_FAQ_EYEBROW,
    TAX_FAQ_Q1, TAX_FAQ_Q2, TAX_FAQ_Q3, TAX_FAQ_Q4, TAX_FAQ_Q5, TAX_FAQ_Q6,
    TAX_FAQ_SUBTITLE, TAX_FAQ_TITLE,
    TAX_HELMET_DESCRIPTION, TAX_HELMET_TITLE,
    TAX_HERO_CTA_BOOK, TAX_HERO_CTA_CALL,
    TAX_HERO_EYEBROW, TAX_HERO_SUBTITLE, TAX_HERO_TITLE, TAX_HERO_TITLE_ACCENT,
    TAX_HERO_TRUST_BILINGUAL, TAX_HERO_TRUST_NOTARY, TAX_HERO_TRUST_PARTNERS,
    TAX_PROCESS_EYEBROW,
    TAX_PROCESS_STEP1_DESC, TAX_PROCESS_STEP1_TITLE,
    TAX_PROCESS_STEP2_DESC, TAX_PROCESS_STEP2_TITLE,
    TAX_PROCESS_STEP3_DESC, TAX_PROCESS_STEP3_TITLE,
    TAX_PROCESS_STEP4_DESC, TAX_PROCESS_STEP4_TITLE,
    TAX_PROCESS_TITLE,
    TAX_SERVICES_EYEBROW, TAX_SERVICES_SUBTITLE, TAX_SERVICES_TITLE,
    TAX_SERVICE_DOCS_DESC, TAX_SERVICE_DOCS_TITLE,
    TAX_SERVICE_FOLLOWUP_DESC, TAX_SERVICE_FOLLOWUP_TITLE,
    TAX_SERVICE_ITIN_DESC, TAX_SERVICE_ITIN_TITLE,
    TAX_SERVICE_NOTARY_DESC, TAX_SERVICE_NOTARY_TITLE,
    TAX_SERVICE_REFERRAL_DESC, TAX_SERVICE_REFERRAL_TITLE,
    TAX_SERVICE_TRANSLATE_DESC, TAX_SERVICE_TRANSLATE_TITLE,
} from '../types';

const en_taxes_page = {
    helmet: {
        [TAX_HELMET_TITLE]: 'Tax Season Help in Miami Lakes | Linares Pro Corp',
        [TAX_HELMET_DESCRIPTION]: 'Bilingual notary and document help for tax season — ITIN applications, document organization, translations, notarization and trusted referrals to licensed tax preparers.',
    },
    section: {
        hero: {
            [TAX_HERO_EYEBROW]: 'Tax season help',
            [TAX_HERO_TITLE]: 'Tax season,',
            [TAX_HERO_TITLE_ACCENT]: 'without the headache.',
            [TAX_HERO_SUBTITLE]: 'We help your family get ready for tax season — ITIN applications, document organization, translations and notarization — and connect you with a trusted, licensed preparer when you need one.',
            [TAX_HERO_CTA_BOOK]: 'Book a free consultation',
            [TAX_HERO_CTA_CALL]: 'Call now',
            [TAX_HERO_TRUST_NOTARY]: 'Florida-commissioned notary',
            [TAX_HERO_TRUST_BILINGUAL]: 'English & Spanish',
            [TAX_HERO_TRUST_PARTNERS]: 'Trusted preparer network',
        },
        disclaimer: {
            [TAX_DISCLAIMER_EYEBROW]: 'A clear, honest note',
            [TAX_DISCLAIMER_TITLE]: 'We are not a CPA firm — and that matters.',
            [TAX_DISCLAIMER_BODY]: 'Linares Pro Corp is a bilingual notary and document-assistance office. We do not file taxes for you and we do not give tax advice. What we do is just as important: we make sure your paperwork is organized, translated, notarized and ready, and we connect you with licensed tax preparers we trust.',
            [TAX_DISCLAIMER_DO_LABEL]: 'What we do',
            [TAX_DISCLAIMER_DO_1]: 'Help you apply for an ITIN (Form W-7)',
            [TAX_DISCLAIMER_DO_2]: 'Organize and review your tax-season documents',
            [TAX_DISCLAIMER_DO_3]: 'Translate and notarize what needs to be official',
            [TAX_DISCLAIMER_DO_4]: 'Refer you to a licensed tax preparer or CPA',
            [TAX_DISCLAIMER_DONT_LABEL]: "What we don't do",
            [TAX_DISCLAIMER_DONT_1]: 'File your tax return for you',
            [TAX_DISCLAIMER_DONT_2]: 'Give legal or tax advice',
            [TAX_DISCLAIMER_DONT_3]: 'Sign or represent you before the IRS',
        },
        services: {
            [TAX_SERVICES_EYEBROW]: 'How we help',
            [TAX_SERVICES_TITLE]: 'Everything around your taxes — handled.',
            [TAX_SERVICES_SUBTITLE]: 'We take care of the documents, translations and notarizations so your tax preparer can focus on what they do best.',
            [TAX_SERVICE_ITIN_TITLE]: 'ITIN application (W-7)',
            [TAX_SERVICE_ITIN_DESC]: 'Step-by-step help preparing your ITIN application and supporting documents.',
            [TAX_SERVICE_DOCS_TITLE]: 'Document organization',
            [TAX_SERVICE_DOCS_DESC]: 'W-2s, 1099s, receipts, statements — sorted and ready before your appointment.',
            [TAX_SERVICE_TRANSLATE_TITLE]: 'Document translation',
            [TAX_SERVICE_TRANSLATE_DESC]: 'Spanish-to-English translations of personal documents your preparer or the IRS may need.',
            [TAX_SERVICE_NOTARY_TITLE]: 'Notary services',
            [TAX_SERVICE_NOTARY_DESC]: 'Florida-commissioned notary public for affidavits, signatures and certified copies.',
            [TAX_SERVICE_REFERRAL_TITLE]: 'Trusted preparer network',
            [TAX_SERVICE_REFERRAL_DESC]: 'When you need a licensed preparer or CPA, we connect you with professionals we trust.',
            [TAX_SERVICE_FOLLOWUP_TITLE]: 'Year-round follow-up',
            [TAX_SERVICE_FOLLOWUP_DESC]: 'IRS letters, ITIN renewals, document updates — we are here after April too.',
        },
        process: {
            [TAX_PROCESS_EYEBROW]: 'How it works',
            [TAX_PROCESS_TITLE]: 'A clear, four-step path through tax season.',
            [TAX_PROCESS_STEP1_TITLE]: 'Free consultation',
            [TAX_PROCESS_STEP1_DESC]: 'Tell us your situation. We map out what you need and what we can help with.',
            [TAX_PROCESS_STEP2_TITLE]: 'Document checklist',
            [TAX_PROCESS_STEP2_DESC]: 'You get a clear list. We help you gather, translate and notarize what is required.',
            [TAX_PROCESS_STEP3_TITLE]: 'Prep & review',
            [TAX_PROCESS_STEP3_DESC]: 'We organize and double-check everything so nothing is missing when filing time comes.',
            [TAX_PROCESS_STEP4_TITLE]: 'Handoff to preparer',
            [TAX_PROCESS_STEP4_DESC]: 'Use your own preparer or a trusted partner from our network — your file is ready to go.',
        },
        checklist: {
            [TAX_CHECKLIST_EYEBROW]: 'Get ready',
            [TAX_CHECKLIST_TITLE]: 'A quick checklist before your appointment.',
            [TAX_CHECKLIST_SUBTITLE]: "Don't worry if you don't have everything — we'll walk through it with you.",
            [TAX_CHECKLIST_GROUP1_TITLE]: 'Identification',
            [TAX_CHECKLIST_GROUP1_ITEM1]: 'Photo ID for every adult in the household',
            [TAX_CHECKLIST_GROUP1_ITEM2]: 'Social Security cards or ITIN letters',
            [TAX_CHECKLIST_GROUP1_ITEM3]: 'Birth certificates for dependents',
            [TAX_CHECKLIST_GROUP2_TITLE]: 'Income documents',
            [TAX_CHECKLIST_GROUP2_ITEM1]: 'W-2 forms from every employer',
            [TAX_CHECKLIST_GROUP2_ITEM2]: '1099 forms (self-employed, contract, etc.)',
            [TAX_CHECKLIST_GROUP2_ITEM3]: 'Other income statements you received',
            [TAX_CHECKLIST_GROUP3_TITLE]: 'Deductions & extras',
            [TAX_CHECKLIST_GROUP3_ITEM1]: 'Mortgage interest or rent statements',
            [TAX_CHECKLIST_GROUP3_ITEM2]: 'Childcare or tuition receipts',
            [TAX_CHECKLIST_GROUP3_ITEM3]: 'Last year tax return (if available)',
        },
        faq: {
            [TAX_FAQ_EYEBROW]: 'Questions',
            [TAX_FAQ_TITLE]: 'Common tax-season questions.',
            [TAX_FAQ_SUBTITLE]: "If you don't see your question, call us — we'll talk you through it.",
            [TAX_FAQ_Q1]: 'Are you CPAs or tax preparers?',
            [TAX_FAQ_A1]: 'No. We are a bilingual notary and document-assistance office. We help you get ready and we refer you to licensed preparers, but we do not file your return ourselves.',
            [TAX_FAQ_Q2]: 'Can you help me apply for an ITIN?',
            [TAX_FAQ_A2]: 'Yes. We help you prepare your W-7 application and the supporting documents the IRS asks for, and we explain each step in your language.',
            [TAX_FAQ_Q3]: 'Do you give tax advice?',
            [TAX_FAQ_A3]: 'No. We do not provide tax advice. For tax decisions we refer you to a licensed preparer or CPA we trust.',
            [TAX_FAQ_Q4]: 'How much do your services cost?',
            [TAX_FAQ_A4]: 'It depends on what you need — ITIN help, translations, notary, document prep. We always give you a clear quote before any work starts.',
            [TAX_FAQ_Q5]: 'Can you help me if I got a letter from the IRS?',
            [TAX_FAQ_A5]: 'We can read the letter with you, explain what it says and help you gather the documents to respond. For representation, we refer you to a licensed professional.',
            [TAX_FAQ_Q6]: 'Do I have to come to your office?',
            [TAX_FAQ_A6]: 'For ITIN, translations and notarization we recommend an in-person visit. Many follow-ups can be handled by phone, email or WhatsApp.',
        },
        cta: {
            [TAX_CTA_TITLE]: 'Get tax season off your shoulders.',
            [TAX_CTA_SUBTITLE]: 'Your first consultation is free. Bring what you have — we will guide you the rest of the way.',
            [TAX_CTA_BUTTON]: 'Book your free consultation',
        },
    },
};

export default en_taxes_page;
